var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.toggleClass,attrs:{"id":"cite"}},[_vm._v("用途地域：「 "),_c('a',{attrs:{"href":"https://www.mlit.go.jp/toshi/tosiko/toshi_tosiko_tk_000087.html","target":"_blank","rel":"noopener noreferrer"}},[_vm._v(" 都市計画決定GISデータ ")]),_vm._v(" 」のデータを加工して作成 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }